import fetchCounter from 'src/api/fetch-counter';


const SET_COUNTER = 'SET_COUNTER';

const setCounter = counter => ({
  type: SET_COUNTER,
  payload: {
    counter
  }
});

const getCounter = () => async (dispatch, getState, { http }) => {
  const [counter] = await fetchCounter({ http })
    .then(data => [data, null])
    .catch(error => [0, error]);

  if (counter) {
    dispatch(setCounter(counter));
  }
};

export {
  SET_COUNTER,
  setCounter,
  getCounter
};
